import {useNavigate, useParams} from "react-router-dom";
import './index.css'
import ProviderGames from "./list";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";

const ProviderDetail = () => {

    const {slug} = useParams()
    const {i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [provider, setProvider] = useState(null)
    const {gameProviders} = useSelector(state => state.globalReducer)

    useEffect(() => {
        const provider = gameProviders?.find(i => i.identifier === slug)
        setProvider(provider)
    }, [slug, gameProviders])


    const navigate = useNavigate()
    const goBack = () =>
        navigate(stringHelper.getLocalizedPath(currentLanguage, '/providers'))
    return (
        <>
            <div className="section section--first">
                <div className="container-fluid d-flex align-items-center g-8 cursor-pointer">
                    <i onClick={goBack} className="ti ti-chevron-left" style={{
                        fontSize: 20
                    }}></i>
                    <div className="container">
                        <h1 onClick={goBack} className="section__title section__title--head">{provider?.name}</h1>
                    </div>
                </div>
            </div>
            <div className="section pt-24 section--first">
                <div className="container">
                    <ProviderGames {...{slug, id: provider?.id}}/>
                </div>
            </div>
        </>

    )

}

export default ProviderDetail
